<template>
	<div class="comp">
		<el-dialog :title="'基本信息'" :visible.sync="dialogState" width="1500px" top="50px">
			<div class="tabLine">
				<div class="tabItem" :class="[curTabIndex==0?'active':'']" @click="changeTab(0)">商品信息</div>
				<div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTab(1)">销售记录</div>
				<div class="tabItem" :class="[curTabIndex==2?'active':'']" @click="changeTab(2)">入库记录</div>
				<div class="tabItem" :class="[curTabIndex==3?'active':'']" @click="changeTab(3)">出库记录</div>
			</div>
			<div v-show="curTabIndex==0">
				<el-table class="table" :data="$public.FSkuCard(goodsMsg.skus_list)" style="width: 100%">
					<el-table-column label="规格" width="400">
						<template slot-scope="scope">
							{{scope.row.skuValue}}
						</template>
					</el-table-column>
					<el-table-column label="单位" width="200">
						<template >
							{{goodsMsg.unit}}
						</template>
					</el-table-column>
					<el-table-column label="价格" width="200">
						<template slot-scope="scope">
							{{scope.row.pprice}}
						</template>
					</el-table-column>
					<el-table-column label="本店库存"  width="200">
						<template slot-scope="scope">
							{{scope.row.stock}}
						</template>
					</el-table-column>
					<el-table-column label="其他门店库存" min-width="180px">
						<template slot-scope="scope">
							<span v-for="(item1,index1) in scope.row.shop_stock" :key="index1">
								<span style="margin-right: 3px;" v-if="item1.shop_id!==''&&item1.shop_id!==curShopId">
									{{item1.shopName}}:{{item1.shop_stock}}
								</span>
							</span>
						</template>
					</el-table-column>
				</el-table>
				<!-- <page :page="page0.page" :total="page0.total" @change="changePage0"></page> -->
			</div>
			<div v-show="curTabIndex==1" >
				<el-table class="table" :data="saleList" style="width: 100%">
					<el-table-column prop="order_no" label="销售单号" width="300">
						<template slot-scope="scope">
							<a style="color:#0000ff;text-decoration: underline;cursor: pointer;"  @click="toOrderDetail(scope.row.order_no)">{{scope.row.order_no}}</a>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="销售日期" >
						<template slot-scope="scope">
							{{$public.FTime(scope.row.sale_time)}}
						</template>
					</el-table-column>
					<el-table-column prop="sku_value" label="规格" width="250">
						<template slot-scope="scope">
							{{scope.row.goods_type==3?scope.row.goods_name:scope.row.sku_value}}
						</template>
					</el-table-column>
					<el-table-column prop="price" label="单价" width="200">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="200">
					</el-table-column>
					<el-table-column prop="unit" label="单位" width="250">
						<template slot-scope="scope">
							{{scope.row.goods_type==3?'套餐':scope.row.unit}}
						</template>
					</el-table-column>
				</el-table>
				<page :page="page1.page" :total="page1.total" @change="changePage1"></page>
			</div>
			<div v-show="curTabIndex==2" >
				<el-table class="table" :data="inList" style="width: 100%">
					<el-table-column prop="inOrderNo" label="入库单号" width="300">
					</el-table-column>
					<el-table-column prop="inOrderType" label="入库类型" >
						<template slot-scope="scope">
							{{scope.row.inOrderType&&scope.row.inOrderType.name}}
						</template>
					</el-table-column>
					<el-table-column prop="inDate" label="入库日期" width="300">
						<template slot-scope="scope">
							{{scope.row.inDate&&$public.FTime(scope.row.inDate)}}
						</template>
					</el-table-column>
					<!-- <el-table-column prop="inCount" label="数量" width="200">
					</el-table-column> -->
				</el-table>
				<page :page="page2.page" :total="page2.total" @change="changePage2"></page>
			</div>
			<div v-show="curTabIndex==3" >
				<el-table class="table" :data="outList" style="width: 100%">
					<el-table-column prop="outOrderNo" label="出库单号" width="300">
					</el-table-column>
					<el-table-column prop="outOrderType" label="出库类型" >
						<template slot-scope="scope">
							{{scope.row.outOrderType&&scope.row.outOrderType.name}}
						</template>
					</el-table-column>
					<el-table-column prop="outDate" label="出库日期" width="300">
						<template slot-scope="scope">
							{{scope.row.outDate&&$public.FTime(scope.row.outDate)}}
						</template>
					</el-table-column>
					<!-- <el-table-column prop="outCount" label="数量" width="200">
					</el-table-column> -->
				</el-table>
				<page :page="page3.page" :total="page3.total" @change="changePage3"></page>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import page from "./page.vue"
	export default {
		components:{page},
		data() {
			return {
				dialogState:true,
				curTabIndex:0,  // 当前tab
				// 分页
				page0:{page:1,pageSize:10,total:0},
				page1:{page:1,pageSize:10,total:0},
				page2:{page:1,pageSize:10,total:0},
				page3:{page:1,pageSize:10,total:0},
				// 列表
				saleList:[],
				inList:[],
				outList:[],
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		props:{
			goodsMsg:{
				default:{}
			}
		},
		watch:{
			dialogState(){
				this.$emit('submit',{type:'close'})
			}
		},
		mounted() {
			console.log(this.goodsMsg)
			this.getSaleList();
			this.getInList();
			this.getOutList();
		},
		methods: {
			changeTab(i){
				this.curTabIndex=i;
				if(i===1){
					this.getSaleList()
				}else if(i===2){
					this.getInList()
				}else if(i===3){
					this.getOutList()
				}
			},
			changePage0(num){
				this.page0.page=num;
			},
			changePage1(num){
				this.page1.page=num;
				this.getSaleList()
			},
			changePage2(num){
				this.page2.page=num;
				this.getInList()
			},
			changePage3(num){
				this.page3.page=num;
				this.getOutList()
			},
			// 获取销售记录
			getSaleList(){
				let params = {
					"goodsId": this.goodsMsg._id,
					pageIndex:this.page1.page,
					pageSize:this.page1.pageSize
				}
				let loading = this.$loading()
				this.$http.post('/api/Order/goodsalelist', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.saleList = res.data.data;
						this.page1.total=res.data.count;
					}
				})
			},
			// 获取入库记录
			getInList(){
				let params = {
					"goodsId": this.goodsMsg._id,
					shopId:this.curShopId,
					pageIndex:this.page2.page,
					pageSize:this.page2.pageSize
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url1+'api/In/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.inList = res.data.data;
						this.page2.total=res.data.count;
					}
				})
			},
			// 获取出库记录
			getOutList(){
				let params = {
					"goodsId": this.goodsMsg._id,
					shopId:this.curShopId,
					pageIndex:this.page3.page,
					pageSize:this.page3.pageSize
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url1+'api/Out/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.outList = res.data.data;
						this.page3.total=res.data.count;
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
.comp {
	.tabLine{
		display: flex;
		.tabItem{
			width:88px;
			line-height: 32px;
			border-radius: 2px;
			text-align: center;
			margin-left:20px;
			margin-bottom:20px;
			border:1px solid rgba(0,0,0,.15);
			cursor: pointer;
			&.active{
				background-color: #1890FF;
				color:#fff;
				border-color:#1890FF;
			}
		}
	}
}
</style>
